// Smart typography: which typed shortcuts turn into their characters.

export const defaultTypographySettings = {
  // Punctuation
  emDash: true,           // -- → —
  ellipsis: true,         // ... → …
  plusMinus: true,        // +/- → ±
  notEqual: true,         // != → ≠
  // Smart Quotes (paired toggles)
  doubleQuotes: true,     // "word" → “word”
  singleQuotes: true,     // 'word' → ‘word’
  // Off: Backspace deletes a curled quote like any other character.
  // On: the first Backspace after one turns it back into a straight quote.
  backspaceRestoresStraightQuotes: false,
  // Arrows
  leftArrow: true,        // <- → ←
  rightArrow: true,       // -> → →
  // Symbols & Trademarks
  copyright: true,        // (c) → ©
  trademark: true,        // (tm) → ™
  registeredTrademark: true, // (r) → ®
  servicemark: true,      // (sm) → ℠
  // Fractions
  oneHalf: true,          // 1/2 → ½
  oneQuarter: true,       // 1/4 → ¼
  threeQuarters: true,    // 3/4 → ¾
  // Math & Typography
  multiplication: true,   // 2x3 → 2×3
  laquo: true,            // << → «
  raquo: true,            // >> → »
  superscriptTwo: true,   // ^2 → ²
  superscriptThree: true, // ^3 → ³
}

export function deepMergeTypography(persisted?: any) {
  if (!persisted) return { ...defaultTypographySettings }
  return { ...defaultTypographySettings, ...persisted }
}
